[
    {
        "inputs":  [
                       {
                           "internalType":  "address",
                           "name":  "_seller",
                           "type":  "address"
                       },
                       {
                           "internalType":  "address",
                           "name":  "_payoutToken",
                           "type":  "address"
                       },
                       {
                           "internalType":  "uint256",
                           "name":  "_amount",
                           "type":  "uint256"
                       },
                       {
                           "internalType":  "uint256",
                           "name":  "_expirationWindow",
                           "type":  "uint256"
                       },
                       {
                           "internalType":  "uint256",
                           "name":  "_dealId",
                           "type":  "uint256"
                       },
                       {
                           "internalType":  "address",
                           "name":  "_reputationRegistry",
                           "type":  "address"
                       },
                       {
                           "internalType":  "address",
                           "name":  "_subnameRegistrar",
                           "type":  "address"
                       },
                       {
                           "internalType":  "string",
                           "name":  "_sellerEns",
                           "type":  "string"
                       },
                       {
                           "internalType":  "address",
                           "name":  "_allowedRouter",
                           "type":  "address"
                       },
                       {
                           "internalType":  "address",
                           "name":  "_feeRecipient",
                           "type":  "address"
                       },
                       {
                           "internalType":  "uint256",
                           "name":  "_protocolFeeBps",
                           "type":  "uint256"
                       },
                       {
                           "internalType":  "address",
                           "name":  "_sellerPayoutAddress",
                           "type":  "address"
                       }
                   ],
        "stateMutability":  "nonpayable",
        "type":  "constructor"
    },
    {
        "inputs":  [

                   ],
        "name":  "AmountZero",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "DealExpired",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "DisallowedRouter",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "ETHEscrowUsesFundInstead",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "ETHForbiddenForTokenEscrow",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "ETHRejectedByTokenEscrow",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "ETHSendFailed",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "ExpirationNotFuture",
        "type":  "error"
    },
    {
        "inputs":  [
                       {
                           "internalType":  "uint256",
                           "name":  "provided",
                           "type":  "uint256"
                       },
                       {
                           "internalType":  "uint256",
                           "name":  "maximum",
                           "type":  "uint256"
                       }
                   ],
        "name":  "FeeBpsTooHigh",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "HandOffAlreadyExpired",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "InputTokenMatchesPayout",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "InvalidFeeRecipient",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "InvalidSeller",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "NotBuyer",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "NotParticipant",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "NotSeller",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "NotYetExpired",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "ReentrancyGuardReentrantCall",
        "type":  "error"
    },
    {
        "inputs":  [
                       {
                           "internalType":  "address",
                           "name":  "token",
                           "type":  "address"
                       }
                   ],
        "name":  "SafeERC20FailedOperation",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "SellerCannotBeBuyer",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "SlippageExceeded",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "SwapCallReverted",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "SwapNotConfigured",
        "type":  "error"
    },
    {
        "inputs":  [
                       {
                           "internalType":  "uint256",
                           "name":  "provided",
                           "type":  "uint256"
                       },
                       {
                           "internalType":  "uint256",
                           "name":  "minimum",
                           "type":  "uint256"
                       }
                   ],
        "name":  "WindowTooShort",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "WrongCodeHash",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "WrongETHAmount",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "WrongState",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "ZeroCodeHash",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "ZeroInputAmount",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "ZeroNewAmount",
        "type":  "error"
    },
    {
        "inputs":  [

                   ],
        "name":  "ZeroPayoutAddress",
        "type":  "error"
    },
    {
        "anonymous":  false,
        "inputs":  [
                       {
                           "indexed":  true,
                           "internalType":  "address",
                           "name":  "seller",
                           "type":  "address"
                       }
                   ],
        "name":  "HandOffCanceled",
        "type":  "event"
    },
    {
        "anonymous":  false,
        "inputs":  [
                       {
                           "indexed":  true,
                           "internalType":  "address",
                           "name":  "seller",
                           "type":  "address"
                       },
                       {
                           "indexed":  true,
                           "internalType":  "address",
                           "name":  "buyer",
                           "type":  "address"
                       },
                       {
                           "indexed":  true,
                           "internalType":  "address",
                           "name":  "sellerPayoutAddress",
                           "type":  "address"
                       },
                       {
                           "indexed":  false,
                           "internalType":  "uint256",
                           "name":  "amount",
                           "type":  "uint256"
                       }
                   ],
        "name":  "HandOffCompleted",
        "type":  "event"
    },
    {
        "anonymous":  false,
        "inputs":  [
                       {
                           "indexed":  false,
                           "internalType":  "uint256",
                           "name":  "newAmount",
                           "type":  "uint256"
                       },
                       {
                           "indexed":  false,
                           "internalType":  "address",
                           "name":  "newPayoutToken",
                           "type":  "address"
                       },
                       {
                           "indexed":  false,
                           "internalType":  "address",
                           "name":  "newSellerPayoutAddress",
                           "type":  "address"
                       },
                       {
                           "indexed":  false,
                           "internalType":  "uint256",
                           "name":  "newExpirationTimestamp",
                           "type":  "uint256"
                       }
                   ],
        "name":  "HandOffEdited",
        "type":  "event"
    },
    {
        "anonymous":  false,
        "inputs":  [
                       {
                           "indexed":  true,
                           "internalType":  "address",
                           "name":  "escrow",
                           "type":  "address"
                       },
                       {
                           "indexed":  true,
                           "internalType":  "address",
                           "name":  "buyer",
                           "type":  "address"
                       },
                       {
                           "indexed":  false,
                           "internalType":  "uint256",
                           "name":  "amount",
                           "type":  "uint256"
                       }
                   ],
        "name":  "HandOffExpired",
        "type":  "event"
    },
    {
        "anonymous":  false,
        "inputs":  [
                       {
                           "indexed":  true,
                           "internalType":  "address",
                           "name":  "buyer",
                           "type":  "address"
                       },
                       {
                           "indexed":  false,
                           "internalType":  "uint256",
                           "name":  "amount",
                           "type":  "uint256"
                       },
                       {
                           "indexed":  false,
                           "internalType":  "bytes32",
                           "name":  "codeHash",
                           "type":  "bytes32"
                       }
                   ],
        "name":  "HandOffFunded",
        "type":  "event"
    },
    {
        "anonymous":  false,
        "inputs":  [
                       {
                           "indexed":  true,
                           "internalType":  "address",
                           "name":  "recipient",
                           "type":  "address"
                       },
                       {
                           "indexed":  false,
                           "internalType":  "uint256",
                           "name":  "amount",
                           "type":  "uint256"
                       }
                   ],
        "name":  "ProtocolFeePaid",
        "type":  "event"
    },
    {
        "anonymous":  false,
        "inputs":  [
                       {
                           "indexed":  true,
                           "internalType":  "address",
                           "name":  "reviewer",
                           "type":  "address"
                       },
                       {
                           "indexed":  false,
                           "internalType":  "bool",
                           "name":  "isPositive",
                           "type":  "bool"
                       }
                   ],
        "name":  "ReviewAttempted",
        "type":  "event"
    },
    {
        "anonymous":  false,
        "inputs":  [
                       {
                           "indexed":  true,
                           "internalType":  "uint256",
                           "name":  "dealId",
                           "type":  "uint256"
                       }
                   ],
        "name":  "SubnameMintFailed",
        "type":  "event"
    },
    {
        "anonymous":  false,
        "inputs":  [
                       {
                           "indexed":  true,
                           "internalType":  "uint256",
                           "name":  "dealId",
                           "type":  "uint256"
                       },
                       {
                           "indexed":  true,
                           "internalType":  "address",
                           "name":  "escrow",
                           "type":  "address"
                       },
                       {
                           "indexed":  false,
                           "internalType":  "address",
                           "name":  "buyer",
                           "type":  "address"
                       },
                       {
                           "indexed":  false,
                           "internalType":  "address",
                           "name":  "seller",
                           "type":  "address"
                       },
                       {
                           "indexed":  false,
                           "internalType":  "uint256",
                           "name":  "amount",
                           "type":  "uint256"
                       },
                       {
                           "indexed":  false,
                           "internalType":  "uint256",
                           "name":  "timestamp",
                           "type":  "uint256"
                       }
                   ],
        "name":  "SubnameMintRequested",
        "type":  "event"
    },
    {
        "inputs":  [

                   ],
        "name":  "ALLOWED_ROUTER",
        "outputs":  [
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "CREATED_AT",
        "outputs":  [
                        {
                            "internalType":  "uint256",
                            "name":  "",
                            "type":  "uint256"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "DEAL_ID",
        "outputs":  [
                        {
                            "internalType":  "uint256",
                            "name":  "",
                            "type":  "uint256"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "FEE_RECIPIENT",
        "outputs":  [
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "MAX_PROTOCOL_FEE_BPS",
        "outputs":  [
                        {
                            "internalType":  "uint256",
                            "name":  "",
                            "type":  "uint256"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "MIN_EXPIRY_WINDOW",
        "outputs":  [
                        {
                            "internalType":  "uint256",
                            "name":  "",
                            "type":  "uint256"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "PROTOCOL_FEE_BPS",
        "outputs":  [
                        {
                            "internalType":  "uint256",
                            "name":  "",
                            "type":  "uint256"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "REPUTATION_REGISTRY",
        "outputs":  [
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "SELLER",
        "outputs":  [
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "SUBNAME_REGISTRAR",
        "outputs":  [
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "amount",
        "outputs":  [
                        {
                            "internalType":  "uint256",
                            "name":  "",
                            "type":  "uint256"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "buyer",
        "outputs":  [
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "buyerEns",
        "outputs":  [
                        {
                            "internalType":  "string",
                            "name":  "",
                            "type":  "string"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "cancel",
        "outputs":  [

                    ],
        "stateMutability":  "nonpayable",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "codeHash",
        "outputs":  [
                        {
                            "internalType":  "bytes32",
                            "name":  "",
                            "type":  "bytes32"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "dealInfo",
        "outputs":  [
                        {
                            "internalType":  "address",
                            "name":  "_seller",
                            "type":  "address"
                        },
                        {
                            "internalType":  "address",
                            "name":  "_buyer",
                            "type":  "address"
                        },
                        {
                            "internalType":  "uint256",
                            "name":  "_expiresAt",
                            "type":  "uint256"
                        },
                        {
                            "internalType":  "uint256",
                            "name":  "_balance",
                            "type":  "uint256"
                        },
                        {
                            "internalType":  "uint8",
                            "name":  "_state",
                            "type":  "uint8"
                        },
                        {
                            "internalType":  "string",
                            "name":  "_sellerEns",
                            "type":  "string"
                        },
                        {
                            "internalType":  "string",
                            "name":  "_buyerEns",
                            "type":  "string"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [
                       {
                           "internalType":  "uint256",
                           "name":  "_newAmount",
                           "type":  "uint256"
                       },
                       {
                           "internalType":  "address",
                           "name":  "_newPayoutToken",
                           "type":  "address"
                       },
                       {
                           "internalType":  "address",
                           "name":  "_newSellerPayoutAddress",
                           "type":  "address"
                       },
                       {
                           "internalType":  "uint256",
                           "name":  "_newExpirationTimestamp",
                           "type":  "uint256"
                       }
                   ],
        "name":  "edit",
        "outputs":  [

                    ],
        "stateMutability":  "nonpayable",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "expirationTimestamp",
        "outputs":  [
                        {
                            "internalType":  "uint256",
                            "name":  "",
                            "type":  "uint256"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [
                       {
                           "internalType":  "bytes32",
                           "name":  "_codeHash",
                           "type":  "bytes32"
                       },
                       {
                           "internalType":  "string",
                           "name":  "_buyerEns",
                           "type":  "string"
                       }
                   ],
        "name":  "fund",
        "outputs":  [

                    ],
        "stateMutability":  "payable",
        "type":  "function"
    },
    {
        "inputs":  [
                       {
                           "internalType":  "address",
                           "name":  "_router",
                           "type":  "address"
                       },
                       {
                           "internalType":  "address",
                           "name":  "_inputToken",
                           "type":  "address"
                       },
                       {
                           "internalType":  "uint256",
                           "name":  "_inputAmount",
                           "type":  "uint256"
                       },
                       {
                           "internalType":  "bytes",
                           "name":  "_swapData",
                           "type":  "bytes"
                       },
                       {
                           "internalType":  "bytes32",
                           "name":  "_codeHash",
                           "type":  "bytes32"
                       },
                       {
                           "internalType":  "string",
                           "name":  "_buyerEns",
                           "type":  "string"
                       }
                   ],
        "name":  "fundWithSwap",
        "outputs":  [

                    ],
        "stateMutability":  "nonpayable",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "getFeeAmount",
        "outputs":  [
                        {
                            "internalType":  "uint256",
                            "name":  "",
                            "type":  "uint256"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "getParticipants",
        "outputs":  [
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        },
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "getRequiredFunding",
        "outputs":  [
                        {
                            "internalType":  "uint256",
                            "name":  "",
                            "type":  "uint256"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "getState",
        "outputs":  [
                        {
                            "internalType":  "enum HandOff.State",
                            "name":  "",
                            "type":  "uint8"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "getTerms",
        "outputs":  [
                        {
                            "internalType":  "uint256",
                            "name":  "",
                            "type":  "uint256"
                        },
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        },
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        },
                        {
                            "internalType":  "uint256",
                            "name":  "",
                            "type":  "uint256"
                        },
                        {
                            "internalType":  "uint256",
                            "name":  "",
                            "type":  "uint256"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "isExpired",
        "outputs":  [
                        {
                            "internalType":  "bool",
                            "name":  "",
                            "type":  "bool"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "payoutToken",
        "outputs":  [
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "refund",
        "outputs":  [

                    ],
        "stateMutability":  "nonpayable",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "sellerEns",
        "outputs":  [
                        {
                            "internalType":  "string",
                            "name":  "",
                            "type":  "string"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "sellerPayoutAddress",
        "outputs":  [
                        {
                            "internalType":  "address",
                            "name":  "",
                            "type":  "address"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [

                   ],
        "name":  "state",
        "outputs":  [
                        {
                            "internalType":  "enum HandOff.State",
                            "name":  "",
                            "type":  "uint8"
                        }
                    ],
        "stateMutability":  "view",
        "type":  "function"
    },
    {
        "inputs":  [
                       {
                           "internalType":  "bool",
                           "name":  "_isPositive",
                           "type":  "bool"
                       }
                   ],
        "name":  "submitReview",
        "outputs":  [

                    ],
        "stateMutability":  "nonpayable",
        "type":  "function"
    },
    {
        "inputs":  [
                       {
                           "internalType":  "bytes32",
                           "name":  "_submittedHash",
                           "type":  "bytes32"
                       }
                   ],
        "name":  "unlock",
        "outputs":  [

                    ],
        "stateMutability":  "nonpayable",
        "type":  "function"
    },
    {
        "stateMutability":  "payable",
        "type":  "receive"
    }
]
